jQuery(document).ready(function ($) {
  var $slider = $(".point-boxes");
  var isSliderActive = false;

  function manageSlider() {
    var windowWidth = $(window).width();

    // Target mobile screens only (under 992px)
    if (windowWidth < 992) {
      if (!isSliderActive) {
        $slider.slick({
          dots: true,
          arrows: false,
          autoplay: false,
          rows: 1,
          slidesPerRow: 1,
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
          autoplay: true,
          autoplaySpeed: 3000,
          pauseOnHover: true,
        });
        isSliderActive = true;
      }
    } else {
      // Unslick completely if stepping onto desktop sizes
      if (isSliderActive) {
        $slider.slick("unslick");
        isSliderActive = false;
      }
    }
  }

  manageSlider();

  $(window).on("resize", function () {
    manageSlider();
  });
});
